export default __webpack_public_path__ + "static/direct-corp.url-49648718ceaaea61dfce9fbc423effe6.svg";